module.exports = __webpack_public_path__ + "96e68675548a3b6d0414675ad37a3b01.MP3";